import { call, put, takeEvery } from "redux-saga/effects"

import { GET_REGISTRATIONS, ADD_NEW_REGISTRATION, UPDATE_REGISTRATION, DELETE_REGISTRATION } from "./actionTypes";
import {
    getRegistrationsSuccess,
    getRegistrationsFail,
    addRegistrationSuccess,
    addRegistrationFail,
    updateRegistrationSuccess,
    updateRegistrationFail,
    deleteRegistrationSuccess,
    deleteRegistrationFail,
   
} from "./actions"

import {
    getRegistrations,
    addNewRegistration,
    updateRegistration,
    deleteRegistration,
   
} from "helpers/registrations/registrations_backend_helper";
import { toast } from "react-toastify";

function* fetchRegistrations() {
    try {
        const response = yield call(getRegistrations)

        yield put(getRegistrationsSuccess(response))
    } catch (error) {
        yield put(getRegistrationsFail(error))
    }
}

function* onAddNewRegistration({ payload }) {
    try {

        
        const response = yield call(addNewRegistration, payload)

        console.log("RESPONSE:", response);
        yield put(addRegistrationSuccess(response.registration))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addRegistrationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateRegistration({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateRegistration, payload)
        yield put(updateRegistrationSuccess(response.registration))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateRegistrationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteRegistration({ payload: data }) {

    try {
        const response = yield call(deleteRegistration, data)
        yield put(deleteRegistrationSuccess(response.registrationId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteRegistrationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* registrationSaga() {
    yield takeEvery(GET_REGISTRATIONS, fetchRegistrations)
    yield takeEvery(ADD_NEW_REGISTRATION, onAddNewRegistration)
    yield takeEvery(UPDATE_REGISTRATION, onUpdateRegistration)
    yield takeEvery(DELETE_REGISTRATION, onDeleteRegistration)
}

export default registrationSaga;